import axios from "axios";
import alert from "@/lang/AlertMessages.js";

export default {
  // Dashboard ------------------------------------------------------------------
  getDashboard({ dispatch, commit }) {
    axios
      .get("Dashboard")
      .then((res) => {
        commit("setDashboard", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ..................  Files  ...................
  getFiles({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/File?pageSize=" +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&time=" +
        data.time +
        "&type=" +
        data.type +
        "&fileGroupingId=" +
        data.fileGroupingId
      )
      .then((res) => {
        commit("setFiles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getFile({ dispatch, commit }, data) {
    axios
      .get("Admin/File/" + data)
      .then((res) => {
        commit("setFile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addFile({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Admin/File", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editFiles({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Team/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteFile({ dispatch }, data) {
    axios
      .delete("admin/File/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  getFileGrouping({ dispatch, commit }, data) {
    axios
      .get("Admin/FileGrouping", data)
      .then((res) => {
        commit("setFileGrouping", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addFileGrouping({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Admin/FileGrouping", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editFileGrouping({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/FileGrouping/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteFileGrouping({ dispatch }, data) {
    axios
      .delete("admin/FileGrouping/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getFilesTime({ dispatch, commit }, data) {
    axios
      .get("Admin/File/LoadTimes", data)
      .then((res) => {
        commit("setFilesTime", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Category Actions -------------------------------------------------------------------------------
  getCategories({ dispatch, commit }) {
    axios
      .get("admin/Group")
      .then((res) => {
        commit("setCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCategoryChilds({ dispatch, commit }, data) {
    axios
      .get("admin/Category/GetTreeJson?GroupId=" + data)
      .then((res) => {
        commit("setCategoryChilds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addMainCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Category", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  addCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Category", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteCategory({ dispatch }, data) {
    axios
      .delete("admin/category/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Category/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ..................  Tickets  ...................
  getTicketCategories({ dispatch, commit }) {
    axios
      .get("admin/TicketType")
      .then((res) => {
        commit("setTicketCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTicketCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/TicketType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTicketCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/TicketType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTicketCategory({ dispatch }, data) {
    axios
      .delete("admin/TicketType/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getWaitingTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setWaitingTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAnsweredTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setAnsweredTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getClosedTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setClosedTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTicket({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket/" + data)
      .then((res) => {
        commit("setTicket", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTicketAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Ticket", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  closeMessage({ dispatch }, data) {
    axios
      .put("admin/Ticket/ChangeClosedStatus/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.done,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteMessage({ dispatch }, data) {
    axios
      .delete("admin/Ticket/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Units Actions -------------------------------------------------------------
  getUnits({ dispatch, commit }) {
    axios
      .get("admin/Unit")
      .then((res) => {
        commit("setUnits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addUnit({ dispatch }, data) {
    axios
      .post("admin/Unit", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editUnit({ dispatch }, data) {
    axios
      .put("admin/Unit/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteUnit({ dispatch }, data) {
    axios
      .delete("admin/Unit/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // blogs ------------------------------------------------------------------
  getPosts({ dispatch, commit }, data) {
    axios
      .get("admin/Post?" + data)
      .then((res) => {
        commit("setPosts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getDeletePosts({ dispatch, commit }, data) {
    axios
      .get("admin/Post?" + data)
      .then((res) => {
        commit("setDeletePosts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPostById({ dispatch, commit }, data) {
    axios
      .get("admin/Post/" + data)
      .then((res) => {
        commit("setPost", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addPost({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Post", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editPost({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Post/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePost({ dispatch }, data) {
    axios
      .delete("admin/Post/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

    deleteDeletedPost({ dispatch }, data) {
        axios
            .delete("admin/Post/ActualDelete/" + data)
            .then((res) => {
                dispatch(
                    "successPOSTHandler",
                    {
                        server: res,
                        message: alert.success.delete,
                        redirect: false,
                    },
                    { root: true }
                );
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            });
    },

  // ..................  Gallery ...................
  getImages({ dispatch, commit }) {
    axios
      .get("admin/ImageGallery")
      .then((res) => {
        commit("setImages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getDeletedImages({ dispatch, commit }, data) {
    axios
      .get("admin/ImageGallery?" + data)
      .then((res) => {
        commit("setDeletedImages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVideos({ dispatch, commit }) {
    axios
      .get("admin/MovieGallery")
      .then((res) => {
        commit("setVideos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getDeletedVideos({ dispatch, commit }, data) {
    axios
      .get("admin/MovieGallery?" + data)
      .then((res) => {
        commit("setDeletedVideos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSounds({ dispatch, commit }) {
    axios
      .get("admin/SoundGallery")
      .then((res) => {
        commit("setSounds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getDeletedSounds({ dispatch, commit }, data) {
    axios
      .get("admin/SoundGallery?" + data)
      .then((res) => {
        commit("setDeletedSounds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getImageById({ dispatch, commit }, data) {
    axios
      .get("admin/GalleryAlbum?galleryId=" + data)
      .then((res) => {
        commit("setImage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Notification Actions -------------------------------------------------------------------------------
  isAdminReadBlog({ commit }, data) {
    axios
      .put("Admin/Post/IsSeen", data)
      .then(() => {
        commit("setUseless", false);
      })
      .catch(() => {
        commit("setUseless", false);
      });
  },
  isAdminReadPostComment({ commit }, data) {
    axios
      .put("Admin/Comment/IsAdminReadPostComment", data)
      .then(() => {
        commit("setUseless", false);
      })
      .catch(() => {
        commit("setUseless", false);
      });
  },
  isAdminReadProductComment({ commit }, data) {
    axios
      .put("Admin/Comment/IsAdminReadProductComment", data)
      .then(() => {
        commit("setUseless", false);
      })
      .catch(() => {
        commit("setUseless", false);
      });
  },

  // .................. Comments ...................
  getProductApprovedComments({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/Comment/LoadProductComment/?pageSize=" +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&fromDate=" +
        data.fromDate +
        "&toDate=" +
        data.toDate +
        "&IsApproved=" +
        data.isApproved
      )
      .then((res) => {
        commit("setApprovedComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductUnapprovedComments({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/Comment/LoadProductComment/?pageSize=" +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&fromDate=" +
        data.fromDate +
        "&toDate=" +
        data.toDate +
        "&IsApproved=" +
        data.isApproved
      )
      .then((res) => {
        commit("setUnapprovedComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductCommentById({ dispatch, commit }, data) {
    axios
      .get("Admin/Comment/GetProductComment/" + data)
      .then((res) => {
        commit("setComment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPostApprovedComments({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/Comment/LoadPostComment/?pageSize=" +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&fromDate=" +
        data.fromDate +
        "&toDate=" +
        data.toDate +
        "&IsApproved=" +
        data.isApproved
      )
      .then((res) => {
        commit("setApprovedComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPostUnapprovedComments({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/Comment/LoadPostComment/?pageSize=" +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&fromDate=" +
        data.fromDate +
        "&toDate=" +
        data.toDate +
        "&IsApproved=" +
        data.isApproved
      )
      .then((res) => {
        commit("setUnapprovedComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPostCommentById({ dispatch, commit }, data) {
    axios
      .get("Admin/Comment/GetPostComment/" + data)
      .then((res) => {
        commit("setComment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editComment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Comment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteComment({ dispatch }, data) {
    axios
      .post("Admin/Comment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  answerProduct({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Comment/AnswerProduct/" + data.id, data.replay)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  answerPost({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Comment/AnswerPost/" + data.id, data.replay)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  // ..................  Banners & Sliders ...................
  getBanners({ dispatch, commit }, data) {
    axios
      .get("admin/Banner?bannerTypeId=" + data)
      .then((res) => {
        commit("setBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addBanner({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Banner", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteBanner({ dispatch }, data) {
    axios
      .delete("admin/Banner/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editBanner({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Banner/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getSliders({ dispatch, commit }) {
    axios
      .get("admin/Slider")
      .then((res) => {
        commit("setSliders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addSlider({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Slider", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editSlider({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Slider/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteSlider({ dispatch }, data) {
    axios
      .delete("admin/Slider/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  SocialNetworks ...................
  getSocialMedia({ dispatch, commit }) {
    axios
      .get("admin/SocialNetwork")
      .then((res) => {
        commit("setSocialMedia", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSocialNetworks({ dispatch, commit }) {
    axios
      .get("admin/SocialNetwork")
      .then((res) => {
        commit("setSocialNetworks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  editSocialNetwork({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/SocialNetwork", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ..................  Menus ...................
  getMenus({ dispatch, commit }) {
    axios
      .get("Admin/Menu")
      .then((res) => {
        commit("setMenus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMenuById({ dispatch, commit }, data) {
    axios
      .get("Admin/Menu/" + data)
      .then((res) => {
        commit("setMenu", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addMenu({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Admin/Menu/CreateChild", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editMenu({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Menu/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteMenu({ dispatch }, data) {
    axios
      .delete("Admin/Menu/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  manage pages ...................
  getPages({ dispatch, commit }) {
    axios
      .get("admin/Page")
      .then((res) => {
        commit("setPages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPageById({ dispatch, commit }, data) {
    axios
      .get("admin/Page/" + data)
      .then((res) => {
        commit("setPage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addPage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Page", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editPage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Page/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePage({ dispatch }, data) {
    axios
      .delete("admin/Page/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  Poster ...................
  getPosters({ dispatch, commit }) {
    axios
      .get("Admin/Poster")
      .then((res) => {
        commit("setPosters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPosterPositions({ dispatch, commit }) {
    axios
      .get("Admin/Poster/LoadPositions")
      .then((res) => {
        commit("setPositions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPosterById({ dispatch, commit }, data) {
    axios
      .get("Admin/Poster/" + data)
      .then((res) => {
        commit("setPage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addPoster({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Admin/Poster", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editPoster({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Poster/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePoster({ dispatch }, data) {
    axios
      .delete("Admin/Poster/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  Widget  ...................
  getWidgets({ dispatch, commit }) {
    axios
      .get("Admin/Widget")
      .then((res) => {
        commit("setWidgets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getWidgetById({ dispatch, commit }, data) {
    axios
      .get("Admin/Widget/" + data)
      .then((res) => {
        commit("setWidget", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getWidgetProducts({ dispatch, commit }) {
    axios
      .get("admin/Product")
      .then((res) => {
        commit("setWidgetItems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getWidgetBlogs({ dispatch, commit }) {
    axios
      .get("admin/Post")
      .then((res) => {
        commit("setWidgetItems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  editWidget({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Widget/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWidget({ dispatch }, data) {
    axios
      .delete("admin/Widget/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Config Actions -------------------------------------------------------------------------------
  getConfig({ dispatch, commit }) {
    axios
      .get("admin/Config")
      .then((res) => {
        commit("setConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getConfigForPanel({ dispatch, commit }) {
    axios
      .get("admin/Config")
      .then((res) => {
        commit("setConfigForPanel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  editConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Config/" + data.id, data.values, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Profile Actions -------------------------------------------------------------------------------
  getProfile({ dispatch, commit }) {
    axios
      .get("admin/Profile")
      .then((res) => {
        commit("setProfile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  editProfile({ dispatch }, data) {
    axios
      .put("admin/Profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editPassword({ dispatch }, data) {
    axios
      .put("admin/Profile/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editAvatar({ dispatch }, data) {
    axios
      .post("admin/Profile", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  deleteAvatar({ dispatch }) {
    axios
      .delete("admin/Profile")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  Cars ...................
  getCars({ dispatch, commit }) {
    axios
      .get("admin/car")
      .then((res) => {
        commit("setCars", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCarById({ dispatch, commit }, data) {
    axios
      .get("admin/car/" + data)
      .then((res) => {
        commit("setCar", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addCar({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/car", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editCar({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/car/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteCar({ dispatch }, data) {
    axios
      .delete("admin/car/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  addCarModel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Car/CreateCarModel", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editCarModel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Car/UpdateCarModel/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteCarModel({ dispatch }, data) {
    axios
      .delete("admin/Car/DeleteCarModel/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  changeCarStatus({ dispatch }, data) {
    axios
      .put("admin/Car/changeStatus/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  SaleType ...................
  getSaleTypes({ dispatch, commit }) {
    axios
      .get("admin/SaleType")
      .then((res) => {
        commit("setSaleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSaleTypeById({ dispatch, commit }, data) {
    axios
      .get("admin/SaleType/" + data)
      .then((res) => {
        commit("setSaleType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/SaleType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/SaleType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteSaleType({ dispatch }, data) {
    axios
      .delete("admin/SaleType/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  Transactions ...................
  getTransactions({ dispatch, commit }, data) {
    axios
      .get("admin/Wallet/Transactions?" + data)
      .then((res) => {
        commit("setTransactions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // ..................  orders(factor) ...................
  getFactors({ dispatch, commit }, data) {
    axios
      .get("admin/Factor?" + data)
      .then((res) => {
        commit("setFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getFinishFactors({ dispatch, commit }, data) {
    axios
      .get("admin/Factor?" + data)
      .then((res) => {
        commit("setFinishFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  factorStatus({ dispatch }, data) {
    axios
      .put("admin/Factor/ChangeStatus/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.done,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // polls ---------------------------------------------------
  getPolls({ dispatch, commit }) {
    axios
      .get("admin/Poll")
      .then((res) => {
        commit("setPolls", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPollById({ dispatch, commit }, data) {
    axios
      .get("admin/Poll/" + data)
      .then((res) => {
        commit("setPollById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  changeIsActive({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Poll/ChangeIsActive/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editPollHeader({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Poll/UpdatePoll/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  addPoll({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Poll", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  addQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Poll/CreateQustion/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addOption({ dispatch, commit }, data) {
    axios
      .post("admin/Poll/CreateQustionOption/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  editOption({ dispatch, commit }, data) {
    axios
      .put("admin/Poll/UpdateQuestionOption/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  deleteOption({ dispatch, commit }, data) {
    axios
      .delete("admin/Poll/DeleteQuestionOption/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  editQustion({ dispatch, commit }, data) {
    axios
      .put("admin/Poll/UpdateQuestion/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  deleteQustion({ dispatch, commit }, data) {
    axios
      .delete("admin/Poll/DeleteQuestion/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  deletePoll({ dispatch }, data) {
    axios
      .delete("admin/Poll/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
   // .................. OrdersSettings ...................
   getOrdersSettings({ dispatch, commit }) {
    axios
      .get("admin/Setting")
      .then((res) => {
        commit("setOrdersSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
 
  editOrderSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
